import { createSlice } from "@reduxjs/toolkit";
import { analyticsAPI } from "../../services/analytics";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const analyticsSlice = createSlice({
  name: "analyticsDetails",
  initialState: data,
  reducers: {
    analyticsInfo(state) {
      state.isLoading = true;
    },
    analyticsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    analyticsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    analyticsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const analyticsDataHandler = (data) => async (dispatch) => {
  try {
    dispatch(analyticsAction.analyticsInfo());
    const response = await analyticsAPI(data);
    dispatch(analyticsAction.analyticsInfoSuccess(response));
  } catch (e) {
    dispatch(analyticsAction.analyticsInfoFailure(e));
  }
};
export default analyticsSlice.reducer;
export const analyticsAction = analyticsSlice.actions;
